const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const { answerStates, formItemTypes } = constants;

/**
 * Checks whether a form item is inactive because one of its
 * parent/ancestor items is a skipped repeater.
 *
 * @param {Array} items - All form items.
 * @param {*} idItem - The ID of the item we want to check.
 * @returns {boolean}
 *   true  = the item has a skipped repeater somewhere above it
 *   false = no skipped repeater ancestor was found
 */
function isInactiveBySkippedRepeaterAncestor(items, idItem) {
   if (!Array.isArray(items) || idItem == null) {
      return false;
   }

   const normalizeId = (id) => (id == null ? null : id.toString().toLowerCase());
   const itemsById = new Map(items.map((item) => [normalizeId(item.id), item]));
   const visited = new Set();
   let current = itemsById.get(normalizeId(idItem));

   while (current && current.idParent != null) {
      const idParent = normalizeId(current.idParent);
      if (visited.has(idParent)) {
         return false;
      }
      visited.add(idParent);

      const parent = itemsById.get(idParent);
      if (!parent) {
         return false;
      }

      const isRepeater = parent.idItemType === formItemTypes.REPEATER.id;
      const isSkipped = (parent.state & answerStates.SKIPPED) === answerStates.SKIPPED;
      if (isRepeater && isSkipped) {
         return true;
      }

      current = parent;
   }

   return false;
}

module.exports = isInactiveBySkippedRepeaterAncestor;
